export default __webpack_public_path__ + "static/media/image-avatar-default.c27c83f1.png";